import Vue from 'vue'
import Router from 'vue-router'
import { KASA_BOOK_21_REDIRECTIONS, SURE_BOOK_21_REDIRECTIONS } from '../constants'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/tr',
      redirect: '/resources'
    },
    // backward compatibility
    {
      path: '/resources',
      redirect: '/resources/search'
    },
    {
      path: '/tr_:id',
      redirect: to => {
        if (to.params.id) {
          return '/resources/search/tr_:id'
        }
      }
    },
    {
      path: '/ar',
      redirect: '/resources'
    },
    {
      path: '/ar_:id',
      redirect: to => {
        if (to.params.id) {
          return '/resources/search/ar_:id'
        }
      }
    },
    {
      path: '/pr',
      redirect: '/resources'
    },
    {
      path: '/pr_:id',
      redirect: to => {
        if (to.params.id) {
          return '/resources/search/pr_:id'
        }
      }
    },
    // Kasa videos (addition to the book 19)
    {
      path: '/kv21/:lang/:id',
      redirect: to => {
        if (to.params.id) {
          return '/resources/search/:lang_vid_:id'
        }
      }
    },
    // Kasa audios in alpha 3 (addition to the book 19)
    {
      path: '/ka321/:lang/:id',
      redirect: to => {
        if (to.params.id) {
          return {
            path: '/resources/search/alpha3_2_:id',
            query: {
              lang: to.params.lang
            }
          }
        }
      }
    },
    {
      path: '/b19/:lang/p/:page',
      redirect: to => {
        if (to.params.page && to.params.lang) {
          return '/resources/lookup/:lang/page/:page'
        }
      }
    },
    {
      path: '/z20/:category/:item',
      redirect: to => {
        if (to.params.category && to.params.item) {
          return `/resources/search/${to.params.category}_${to.params.item}`
        }
      }
    },
    // SuRe 2021 book
    {
      path: '/s21/:item',
      redirect: to => {
        if (to.params.item && SURE_BOOK_21_REDIRECTIONS[to.params.item] !== undefined) {
          location.href = SURE_BOOK_21_REDIRECTIONS[to.params.item]
        }
      }
    },
    // Kasa 2021 book
    {
      path: '/k21/:item',
      redirect: to => {
        if (to.params.item && KASA_BOOK_21_REDIRECTIONS[to.params.item] !== undefined) {
          location.href = KASA_BOOK_21_REDIRECTIONS[to.params.item]
        } else {
          return `/resources/k21/${to.params.item}`
        }
      }
    },
    // Material of kasa 2021 book (links directly to content, which couldn't be printed in the book)
    {
      path: '/k21m/:item/:ext',
      name: 'ResoureceK21m',
      component: require('@/components/ResourceKasaBook21m').default
      // redirect: to => {
      //   window.location.href = `/static/kasa_book_21/${to.params.item}.${to.params.ext}`
      // }
    },
    {
      path: '/resources/k21/:searchString',
      name: 'ResourceSearchK21',
      component: require('@/components/ResourceKasaBook21').default
    },
    {
      path: '/home',
      name: 'Home',
      component: require('@/components/Home').default
    },
    {
      path: '/resources/search',
      name: 'ResourceSearch',
      component: require('@/components/ResourceSearch').default
    },
    {
      path: '/resources/list',
      name: 'ResourceList',
      component: require('@/components/ResourceList').default
    },
    {
      path: '/resources/topicList',
      name: 'ResourceTopicList',
      component: require('@/components/ResourceTopicList').default
    },
    {
      path: '/resources/search/:searchString',
      name: 'ResourceSearchWithString',
      component: require('@/components/ResourceSearch').default
    },
    {
      path: '/resources/lookup/:lang/page/:page',
      name: 'ResourceLookupLangPage',
      component: require('@/components/ResourceLookup').default
    },
    {
      path: '/impress',
      name: 'Impress',
      component: require('@/components/Impress').default
    },
    {
      path: '*',
      name: 'error',
      component: require('@/components/ErrorPage').default
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js